import React from "react";
import { Grid } from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget";
import PageTitle from "../../Components/PageTitle";
import WebsiteAnalyser from "../../Components/WebsiteAnalyser/WebsiteAnalyser";
import PornCheck from "../../Components/PornCheck/PornCheck";
import PiracyPornAnalyser from "../../Components/PiracyPornAnalyser/PiracyPornAnalyser";

export default function WebsiteAnalyserPage() {
  var classes = useStyles();

  return (
    <>
      <PageTitle title="Website Analyser" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title=""
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
          >
            <WebsiteAnalyser />
          </Widget>
        </Grid>
      </Grid>

      <PageTitle title="Porn / Piracy Check" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title=""
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
          >
            <PornCheck />
          </Widget>
        </Grid>
      </Grid>

      <PageTitle title="Piracy / Porn Analyser" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget
            title=""
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
          >
            <PiracyPornAnalyser />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
